import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(( theme ) => ({
  root: {
    margin: 8,
    width: "calc(100% - 16px)",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.props.border,
    borderRadius: 5,
    backgroundColor: theme.palette.background.paper,
    padding: 8,
    cursor: "pointer",
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
    scrollMarginTop: "8px",
  },
  focused: {
    cursor: "default",
    borderColor: theme.palette.primary.main,
  },
  componentName: {
    fontSize: 14,
    fontWeight: 600,
    padding: 8,
    "&:not(:hover) .hoverIcon": {
      zIndex: -1,
      opacity: "0 !important",
    },
  },
  title: {
    cursor: "pointer",
    textDecoration: "none",
    "-webkit-transition": "text-decoration 0.4s ease",
    transition: "text-decoration 0.4s ease",
    textOverflow: "ellipsis",
    overflow: "hidden",
    textWrap: "nowrap",
    "&:hover": {
      textDecoration: "underline",
      color: theme.palette.primary.main,
    },
  },
  newComment: {
    marginLeft: 4,
    marginRight: 4,
    borderRadius: 50,
    backgroundColor: theme.palette.warning.main,
    color: theme.props.text.alt,
    padding: "2px 8px",
    height: "max-content",
    fontSize: 12,
  },
  navi: {
    fontSize: "16px !important",
    letterSpacing: "normal !important",
    fontWeight: "normal !important",
    marginBottom: -1,
  },
}));

export default useStyle;